import type { FilterResumeType, ResumeDto } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";
import { axios } from "@/client/libs/axios";
import qs from "qs";

export const fetchAllResumes = async (page: number, filter?: FilterResumeType | null) => {
  if (filter) {
    const response = await axios.get<
      { page: number; data: ResumeDto[] },
      AxiosResponse<{ page: number; data: ResumeDto[] }>
    >("/resume/admin", {
      params: {
        page: page,
        ...filter,
      },
      paramsSerializer: (param) => {
        return qs.stringify(param);
      },
    });
    console.log(response.data);
    return response.data;
  }
  const response = await axios.get<
    { page: number; data: ResumeDto[] },
    AxiosResponse<{ page: number; data: ResumeDto[] }>
  >("/resume/admin", {
    params: {
      page: page,
    },
  });
  console.log(response.data);
  return response.data;
};

export const useResumes = (page: number, filter?: FilterResumeType | null) => {
  const {
    error,
    isPending: loading,
    data: resumes,
  } = useQuery({
    queryKey: ["resumes", page, filter],
    queryFn: () => fetchAllResumes(page, filter),
  });

  return { resumes, loading, error };
};
